module.exports = __webpack_public_path__ + "img/join_us1.d1cc6437.jpg";